import { useState } from "react";
import { X, FileText } from "lucide-react";

const BULAN = [
    "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function RekapBulananModal({ open, onClose, onCetak }) {
    const now = new Date();
    const [bulan, setBulan] = useState(now.getMonth() + 1);
    const [tahun, setTahun] = useState(now.getFullYear());

    if (!open) return null;

    const tahunOpts = [];
    for (let y = now.getFullYear() + 1; y >= now.getFullYear() - 4; y--) tahunOpts.push(y);

    const handleCetak = () => {
        onCetak(bulan, tahun);
    };

    return (
        <div className="fixed inset-0 bg-slate-900/50 z-50 grid place-items-center p-4"
             onClick={onClose} data-testid="rekap-bulanan-modal">
            <div className="bg-white rounded-lg w-full max-w-md shadow-2xl" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
                    <h2 className="font-bold text-slate-900 text-sm">Cetak Rekap Bulanan</h2>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-700"
                            data-testid="rekap-modal-close">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-5 space-y-4">
                    <p className="text-xs text-slate-500">
                        Pilih bulan dan tahun untuk menghasilkan rekap aktivitas semua vendor.
                    </p>

                    <div>
                        <label className="block text-xs font-medium text-slate-700 mb-1">Bulan</label>
                        <select value={bulan} onChange={(e) => setBulan(parseInt(e.target.value))}
                                data-testid="rekap-bulan"
                                className="w-full border border-slate-300 rounded px-3 py-2 text-sm bg-white focus:border-teal-500 focus:outline-none">
                            {BULAN.map((b, i) => (
                                <option key={i} value={i + 1}>{b}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-xs font-medium text-slate-700 mb-1">Tahun</label>
                        <select value={tahun} onChange={(e) => setTahun(parseInt(e.target.value))}
                                data-testid="rekap-tahun"
                                className="w-full border border-slate-300 rounded px-3 py-2 text-sm bg-white focus:border-teal-500 focus:outline-none">
                            {tahunOpts.map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-slate-200 bg-slate-50">
                    <button onClick={onClose} data-testid="rekap-batal"
                            className="px-4 py-2 border border-slate-300 text-slate-700 hover:bg-slate-100 rounded font-medium text-sm">
                        Batal
                    </button>
                    <button onClick={handleCetak} data-testid="rekap-cetak-submit"
                            className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded font-medium text-sm inline-flex items-center gap-1.5">
                        <FileText className="w-4 h-4" /> Cetak Rekap
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RekapBulananModal;
